import {capitalize} from '../../../../../utils/string.utils';

export interface WoundMapEntry {
    name: string;
    LR?: boolean;
    FB?: boolean;
    id: string;
    optionGroup: string;
}

export const WoundMap: {[key: string]: WoundMapEntry} = {
    WL_TOPHEAD: {
        name: 'Top of Head',
        FB: true,
        id: 'WL_TOPHEAD',
        optionGroup: 'Head',
    },
    WL_FOREHEAD: {
        name: 'Forehead',
        id: 'WL_FOREHEAD',
        optionGroup: 'Head',
    },
    WL_EAR: {
        name: 'Ear',
        LR: true,
        id: 'WL_EAR',
        optionGroup: 'Head',
    },
    WL_NOSE: {
        name: 'Nose',
        id: 'WL_NOSE',
        optionGroup: 'Head',
    },
    WL_CHEEK: {
        name: 'Cheek',
        LR: true,
        id: 'WL_CHEEK',
        optionGroup: 'Head',
    },
    WL_CHIN: {
        name: 'Chin',
        id: 'WL_CHIN',
        optionGroup: 'Head',
    },
    WL_NECK: {
        name: 'Neck',
        id: 'WL_NECK',
        LR: true,
        FB: true,
        optionGroup: 'Head',
    },
    WL_SHOULDER: {
        name: 'Shoulder',
        id: 'WL_SHOULDER',
        LR: true,
        FB: true,
        optionGroup: 'Hand',
    },
    WL_ARMPIT: {
        name: 'Armpit',
        id: 'WL_ARMPIT',
        LR: true,
        optionGroup: 'Hand',
    },
    WL_UPPERARM: {
        name: 'Upper Arm',
        id: 'WL_UPPERARM',
        LR: true,
        FB: true,
        optionGroup: 'Hand',
    },
    WL_ELBOW: {
        name: 'Elbow',
        id: 'WL_ELBOW',
        LR: true,
        FB: true,
        optionGroup: 'Hand',
    },
    WL_FOREARM: {
        name: 'Forearm',
        id: 'WL_FOREARM',
        LR: true,
        FB: true,
        optionGroup: 'Hand',
    },
    WL_HAND: {
        name: 'Hand',
        id: 'WL_HAND',
        LR: true,
        FB: true,
        optionGroup: 'Hand',
    },
    WL_FINGERS: {
        name: 'Fingers',
        id: 'WL_FINGERS',
        LR: true,
        optionGroup: 'Hand',
    },
    WL_CHEST: {
        name: 'Chest',
        id: 'WL_CHEST',
        LR: true,
        optionGroup: 'Upper Body',
    },
    WL_STERNUM: {
        name: 'Sternum',
        id: 'WL_STERNUM',
        optionGroup: 'Upper Body',
    },
    WL_RIBCAGE: {
        name: 'Ribcage',
        id: 'WL_RIBCAGE',
        optionGroup: 'Upper Body',
        LR: true,
    },
    WL_ABDOMEN: {
        name: 'Abdomen',
        id: 'WL_ABDOMEN',
        optionGroup: 'Upper Body',
        LR: true,
    },
    WL_BELLYBUTTON: {
        name: 'Belly Button',
        id: 'WL_BELLYBUTTON',
        optionGroup: 'Upper Body',
    },
    WL_HIP: {
        name: 'Hip',
        id: 'WL_HIP',
        optionGroup: 'Upper Body',
        LR: true,
    },
    WL_GENITALIA: {
        name: 'Genitalia',
        id: 'WL_GENITALIA',
        optionGroup: 'Upper Body',
    },
    WL_THIGH: {
        name: 'Thigh',
        id: 'WL_THIGH',
        LR: true,
        FB: true,
        optionGroup: 'Leg',
    },
    WL_KNEE: {
        name: 'Knee',
        id: 'WL_KNEE',
        LR: true,
        FB: true,
        optionGroup: 'Leg',
    },
    WL_SHIN: {
        name: 'Shin',
        id: 'WL_SHIN',
        LR: true,
        optionGroup: 'Leg',
    },
    WL_FOOT: {
        name: 'Foot',
        id: 'WL_FOOT',
        LR: true,
        FB: true,
        optionGroup: 'Leg',
    },
    WL_TOES: {
        name: 'Toes',
        id: 'WL_TOES',
        LR: true,
        optionGroup: 'Leg',
    },
    WL_BACKOFHEAD: {
        name: 'Back of Head',
        id: 'WL_BACKOFHEAD',
        optionGroup: 'Head',
    },
    WL_SCAPULA: {
        name: 'Scapula',
        id: 'WL_SCAPULA',
        LR: true,
        optionGroup: 'Upper Body',
    },
    WL_BACK: {
        name: 'Back',
        id: 'WL_BACK',
        LR: true,
        optionGroup: 'Upper Body',
    },
    WL_BACKLOWER: {
        name: 'Lower Back',
        id: 'WL_BACKLOWER',
        LR: true,
        optionGroup: 'Upper Body',
    },
    WL_SPINE: {
        name: 'Spine',
        id: 'WL_SPINE',
        optionGroup: 'Upper Body',
    },
    WL_LUMBARSPINE: {
        name: 'Lumbar Spine',
        id: 'WL_LUMBARSPINE',
        optionGroup: 'Upper Body',
    },
    WL_SACRUM: {
        name: 'Sacrum',
        id: 'WL_SACRUM',
        optionGroup: 'Upper Body',
    },
    WL_COCCYX: {
        name: 'Coccyx',
        id: 'WL_COCCYX',
        optionGroup: 'Upper Body',
    },
    WL_GLUTEALCLEFT: {
        name: 'Gluteal Cleft',
        id: 'WL_GLUTEALCLEFT',
        optionGroup: 'Upper Body',
    },
    WL_PERINEALAREA: {
        name: 'Perineal Area',
        id: 'WL_PERINEALAREA',
        optionGroup: 'Upper Body',
    },
    WL_CALF: {
        name: 'Calf',
        id: 'WL_CALF',
        optionGroup: 'Leg',
        LR: true,
    },
    WL_HEEL: {
        name: 'Heel',
        id: 'WL_HEEL',
        optionGroup: 'Leg',
        LR: true,
    },
    WL_ANKLE: {
        name: 'Ankle',
        id: 'WL_ANKLE',
        optionGroup: 'Leg',
        LR: true,
    },
    WL_BALLOFFOOT: {
        name: 'Ball of Foot',
        id: 'WL_BALLOFFOOT',
        optionGroup: 'Leg',
        LR: true,
    },
    WL_ISCHIALTUBEROSITY: {
        name: 'Ischial Tuberosity',
        id: 'WL_ISCHIALTUBEROSITY',
        optionGroup: 'Lower Body',
        LR: true,
    },
};

export function getWoundLocationName(location: string | any) {
    if (!location) return location;
    
    // Handle object format (new WoundLocationSerializer)
    if (typeof location === 'object' && location !== null) {
        // If it has display_name, use it
        if (location.display_name) {
            return location.display_name;
        }
        
        // Build display name from parts if we have the data
        const displayParts: string[] = [];
        
        // Note: We don't have access to the full location data here,
        // so we rely on the backend to provide display_name
        // This is just a fallback for basic display
        if (location.anatomical_location) {
            // Try to get name from the old format ID
            const idStr = String(location.anatomical_location);
            if (idStr.startsWith('WL_')) {
                const parts = idStr.split('_');
                if (parts[1] && WoundMap[`WL_${parts[1]}`]?.name) {
                    displayParts.push(WoundMap[`WL_${parts[1]}`].name);
                }
            } else {
                displayParts.push(idStr);
            }
        }
        
        // Add side if present
        if (location.side) {
            displayParts.push(capitalize(location.side));
        }
        
        // Add modifiers if present (array of IDs or names)
        if (location.anatomical_modifiers && Array.isArray(location.anatomical_modifiers)) {
            // If they are strings/names, add them
            location.anatomical_modifiers.forEach((mod: any) => {
                if (typeof mod === 'string' && !mod.match(/^\d+$/)) {
                    displayParts.push(mod);
                }
            });
        }
        
        if (displayParts.length > 0) {
            return displayParts.join(', ');
        }
        
        // Last resort - stringify it
        return JSON.stringify(location);
    }
    
    // Handle string format (old format)
    if (typeof location !== 'string') {
        return String(location);
    }
    
    const parts = location.split('_');
    if (parts[1] && WoundMap[`WL_${parts[1]}`]?.name) {
        return [WoundMap[`WL_${parts[1]}`].name, capitalize(parts[2]?.toLowerCase()), capitalize(parts[3]?.toLowerCase())].filter(x => x).join(', ');
    }
    return location;
}

export function getSimplifiedWoundLocationMap(): {name: string; id: string; parent?: string}[] {
    const locationMap = [];
    Object.keys(WoundMap).forEach(key => {
        if (WoundMap[key].LR && WoundMap[key].FB) {
            locationMap.push({name: `${WoundMap[key].name}, Left, Front`, id: `${key}_LEFT_FRONT`, parent: WoundMap[key].optionGroup});
            locationMap.push({name: `${WoundMap[key].name}, Right, Front`, id: `${key}_RIGHT_FRONT`, parent: WoundMap[key].optionGroup});
            locationMap.push({name: `${WoundMap[key].name}, Left, Back`, id: `${key}_LEFT_BACK`, parent: WoundMap[key].optionGroup});
            locationMap.push({name: `${WoundMap[key].name}, Right, Back`, id: `${key}_RIGHT_BACK`, parent: WoundMap[key].optionGroup});
        } else if (WoundMap[key].FB) {
            locationMap.push({name: `${WoundMap[key].name}, Front`, id: `${key}_FRONT`, parent: WoundMap[key].optionGroup});
            locationMap.push({name: `${WoundMap[key].name}, Back`, id: `${key}_BACK`, parent: WoundMap[key].optionGroup});
        } else if (WoundMap[key].LR) {
            locationMap.push({name: `${WoundMap[key].name}, Left`, id: `${key}_LEFT`, parent: WoundMap[key].optionGroup});
            locationMap.push({name: `${WoundMap[key].name}, Right`, id: `${key}_RIGHT`, parent: WoundMap[key].optionGroup});
        } else {
            locationMap.push({name: `${WoundMap[key].name}`, id: `${key}`, parent: WoundMap[key].optionGroup});
        }
    });
    return locationMap;
}
